/**
 * Footer.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { SITE_TAGLINE } from '../constants/siteTagline';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="site-footer compact-footer">
      <div className="footer-main compact-main">
        <div className="footer-row footer-tagline-row">
          <p className="footer-tagline">{SITE_TAGLINE}</p>
        </div>
        <div className="footer-row compact-links-row">
          <a href="/privacy-policy" className="footer-link">🔒 {t.footer.privacy}</a>
          <a href="/terms-of-use" className="footer-link">📋 {t.footer.terms}</a>
          <button
            type="button"
            className="footer-link"
            onClick={() => window.dispatchEvent(new Event('openCookiePreferences'))}
          >
            🍪 {t.footer.preferences}
          </button>
          <a href="/developer" className="footer-link footer-dev-link" title="About the Developer">👨‍💻</a>
          <a href="/return-policy" className="footer-link">↩️ {t.footer.returns}</a>
          <a href="/shipping-policy" className="footer-link">📦 {t.footer.shipping}</a>
          <a href="/faq" className="footer-link">❓ {t.footer.faq}</a>
          <a href="/contact" className="footer-link">✉️ {t.footer.contact}</a>
        </div>

        <div className="footer-row compact-disclaimer-row">
          <small className="footer-disclaimer">
            {t.footer.disclaimer}
          </small>
        </div>

      </div>
    </footer>
  );
} 